import { Injectable } from '@angular/core';
import { format, parse, parseISO, isMatch, isValid, formatISO } from 'date-fns';
import { cs } from 'date-fns/locale';

@Injectable({ providedIn: 'root' })

/** Pomocné funkce pro práci s datem a časem */
export class DateTimeHelper {
  static readonly validDateTimeFormats = ['dd. MM. yyyy HH:mm', 'dd. MM. yyyy HHmm', 'dd.MM.yyyy HHmm', 'dd.MM.yyyy HH:mm'];
  static readonly validDateFormats = ['dd. MM. yyyy', 'dd.MM.yyyy',
    'dd', 'dd.', 'dd.MM', 'dd.MM.', 'dd. MM', 'dd. MM.'];

  static parseDateTimeIso(value: string | null): Date {
    return parseISO(value!);
  }

  static parseDateTime(value: string): Date | null {
    let format: string | null = null;
    for (const dateFormat of [...this.validDateTimeFormats, ...this.validDateFormats]) {
      if (isMatch(value, dateFormat)) {
        format = dateFormat;
      }
    }
    if (format == null) {
      return null;
    }
    return parse(value, format, new Date());
  }

  static parseDate(value: string): Date | null {
    let format: string | null = null;
    this.validDateFormats.forEach(x => {
      if (isMatch(value, x)) {
        format = x;
      }

      return true;
    });

    if (format == null) {
      return null;
    }
    return parse(value, format, new Date());
  }

  static isValidDateTimeIso(value: string): boolean {
    const date = DateTimeHelper.parseDateTimeIso(value);
    return isValid(date);
  }

  static toIsoString(date: Date) {
    if (!date) {
      return null;
    }
    return formatISO(date);
  }

  static toDateTimeString(date?: Date | null) {
    if (!date) {
      return null;
    }
    return format(date, 'P p', { locale: cs });
  }

  static toDateString(date?: Date | null) {
    if (!date) {
      return null;
    }
    return format(date, 'P', { locale: cs });
  }

  static formatDateTime(date: Date | null) {
    if (!date)
      return '';

    if (date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1)
      return '';
    return format(date, 'd.M.yyyy H:mm:ss');
  }

  static formatTime(date: Date | null) {
    if (!date)
      return '';

    if (date.getFullYear() === 1 && date.getMonth() === 0 && date.getDate() === 1)
      return '';
    return format(date, 'H:mm');
  }
}
